import { DocumentId } from '../types/document-row';

/**
 * Two id shapes reach the frontend. APIDefinition.yaml §7 promises prefixed strings
 * (`PURCHASE_DELIVERY_NOTE_912455`) and says the frontend must never strip the prefix,
 * but the deployed query service answers with the bare primary key. Everything that
 * has to interpret an id goes through here so both shapes behave the same.
 */

/** The numeric key the monolith's archive endpoints expect, from either shape. */
export function rawDocumentId(id: DocumentId | null | undefined): number | null {
  if (id === null || id === undefined) return null;
  const last = String(id).split('_').pop();
  if (!last) return null;
  const raw = Number(last);
  return Number.isFinite(raw) ? raw : null;
}

/** The id the deployed link service takes: the bare numeric key, from either shape.
 *  Its DTO is numeric despite the prefixed-string contract — a prefixed string dies in
 *  deserialization (default 400 on create, 500 on delete; probed 2026-09-21). */
export function linkServiceId(id: DocumentId): DocumentId;
export function linkServiceId(id: DocumentId | null | undefined): DocumentId | null;
export function linkServiceId(id: DocumentId | null | undefined): DocumentId | null {
  if (id === null || id === undefined || id === '') return null;
  return rawDocumentId(id) ?? id;
}

/** Map and set key for an id, so a number and its string form never split in two. */
export function documentKey(id: DocumentId | null | undefined): string | null {
  if (id === null || id === undefined || id === '') return null;
  return String(id);
}
